import { Text } from '@mantine/core'

import { useTranslation } from '@flecto/translations'
import { Modal, useModal, useNotifications } from '@flecto/ui'

import { useLinkAccount } from '../../hooks/useLinkAccount'

export function ModalConfirmationPermission() {
  const { closeModal } = useModal()
  const { showNotification } = useNotifications()
  const { t } = useTranslation('saas', { keyPrefix: 'profile_account' })
  const { authenticateUser } = useLinkAccount()

  const handleConfirm = async () => {
    try {
      await authenticateUser()
      closeModal()
    } catch {
      showNotification({
        type: 'error',
        message: t('notifications.alert_error_general'),
      })
    }
  }

  return (
    <Modal size='md'>
      <Modal.Icon variant='warning' />
      <Modal.Title>{t('modal_confirmation_permission.title')}</Modal.Title>
      <Modal.Content>
        <Text>{t('modal_confirmation_permission.description')}</Text>
      </Modal.Content>
      <Modal.Cancel>
        {t('modal_confirmation_permission.buttonCancel')}
      </Modal.Cancel>
      <Modal.Submit onClick={() => handleConfirm()}>
        {t('modal_confirmation_permission.buttonLogout')}
      </Modal.Submit>
    </Modal>
  )
}
